export const ReleaseModeCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sportello',
    path: '/sportello',
  },
  {
    name: 'Modalità rilascio',
    path: '/sportello/modalita-rilascio',
  },
];
